window.DUMDUM_TYPE_FEATURES = {
  "serialf-regular": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-thin": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-light": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-book": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-medium": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-semibold": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-bold": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-xl": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-medium": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-xxl": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ],
  "serialf-xxxl": [
    { "tag": "aalt", "label": "All alternates" },
    { "tag": "case", "label": "Case-sensitive" },
    { "tag": "dlig", "label": "Discretionary ligatures" },
    { "tag": "fwid", "label": "Full width" },
    { "tag": "liga", "label": "Ligatures" },
    { "tag": "ordn", "label": "Ordinals" },
    { "tag": "sinf", "label": "Scientific inferiors" },
    { "tag": "ss01", "label": "SS01" },
    { "tag": "ss02", "label": "SS02" },
    { "tag": "ss03", "label": "SS03" },
    { "tag": "ss04", "label": "SS04" },
    { "tag": "ss05", "label": "SS05" },
    { "tag": "ss06", "label": "SS06" },
    { "tag": "ss07", "label": "SS07" },
    { "tag": "subs", "label": "Subscript" },
    { "tag": "sups", "label": "Superscript" }
  ]
};
